<div mat-dialog-header>
  <h1><mat-icon>warning</mat-icon>{{ headline }}</h1>
</div>
<div mat-dialog-content class="dialog-container col-12">
  <div class="inner row col-12" [innerHTML]="content"></div>
  <div class="inner row col-12 mt-3">
    <mat-form-field class="me-2">
      <mat-label>Rep Code</mat-label>
      <input
        matInput
        placeholder="Rep Code"
        [(ngModel)]="Client.BackOfficeRRCode"
      />
    </mat-form-field>
    <mat-form-field class="me-2">
      <mat-label>Office Range</mat-label>
      <input
        matInput
        placeholder="Office Range"
        [(ngModel)]="Client.BackOfficeOfficeCode"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Account Type</mat-label>
      <mat-select [(ngModel)]="Client.BackOfficeAccountTypeCode">
        @for (opt of accountTypes; track opt) {
          <mat-option [value]="opt.RBAccountTypeCode">{{
            opt.AccountTypeName
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div mat-dialog-actions class="buttons row">
  <button
    type="button"
    mat-raised-button
    color="accent"
    [disabled]="!Client.BackOfficeOfficeCode || !Client.BackOfficeRRCode"
    (click)="generateReport()"
    >Submit</button
  >
  <button type="button" mat-raised-button (click)="cancel()">Cancel</button>
</div>

<ngx-loading [show]="loading" />
